// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"237":"95db70cd","494":"ac740dbc","586":"5851b12b","657":"6f097f6f","921":"d574d87a"}[chunkId] + ".chunk.js";
};